import styled, { css } from 'styled-components';

export const TeamWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  flex-direction: row;
  margin: 0.3em 0;
`;

export const TeamLogo = styled.img`
  height: 28px;
  ${props => props.height && css`
    height: ${props.height};
  `};
  ${props => props.width && css`
    width: ${props.width};
  `};
  ${props => props.isVolleyCalendarChampionship && css`
    height: 28px;
    width: auto;
  `};
  image-rendering: optimizeSpeed;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: optimize-contrast;
  -ms-interpolation-mode: nearest-neighbor;
`;

export const TeamName = styled.div`
  color: ${props => props.color};
  font-weight: ${props => props.weight};
  margin-left: ${props => props.marginLeft}em;
  text-align: left;
  ${props => (props.font) && css` 
  font-family: ${props.theme.fontSets[props.font]};
  font-size: 15px;
  `};
  ${props => props.theme.mediaQueries.small_phone}{
  font-size: 12px;
  }
  ${props => props.isLoserCrossed && css` 
  text-decoration: line-through;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/TeamLabel/styles.js